// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAXKd4QQPNiNao4lVBIs0163hn9MHKZrY4",
//   authDomain: "wlab-19435.firebaseapp.com",
//   projectId: "wlab-19435",
//   storageBucket: "wlab-19435.firebasestorage.app",
//   messagingSenderId: "1438258553",
//   appId: "1:1438258553:web:e7c63d461e6fe2b9418ba8",
//   measurementId: "G-Y7WQRQGYSW"
// };

const firebaseConfig = {
    apiKey: "AIzaSyAfw1zInpxJPk5iRuARNJD-TTseyR5bJZk",
    authDomain: "wlab-19435.firebaseapp.com",
    projectId: "wlab-19435",
    storageBucket: "wlab-19435.firebasestorage.app",
    messagingSenderId: "1438258553",
    appId: "1:1438258553:web:8a067fd93d82a425418ba8",
    measurementId: "G-NJ9TBK04WF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app)
// const analytics = getAnalytics(app);

export { db, storage, auth }